"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 12 * MONTH;
exports.Time = { SECOND, MINUTE, HOUR, DAY, WEEK, MONTH, YEAR };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGltZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9UaW1lLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQU0sTUFBTSxHQUFHLElBQUksQ0FBQTtBQUNuQixNQUFNLE1BQU0sR0FBRyxFQUFFLEdBQUcsTUFBTSxDQUFBO0FBQzFCLE1BQU0sSUFBSSxHQUFHLEVBQUUsR0FBRyxNQUFNLENBQUE7QUFDeEIsTUFBTSxHQUFHLEdBQUcsRUFBRSxHQUFHLElBQUksQ0FBQTtBQUNyQixNQUFNLElBQUksR0FBRyxDQUFDLEdBQUcsR0FBRyxDQUFBO0FBQ3BCLE1BQU0sS0FBSyxHQUFHLEVBQUUsR0FBRyxHQUFHLENBQUE7QUFDdEIsTUFBTSxJQUFJLEdBQUcsRUFBRSxHQUFHLEtBQUssQ0FBQTtBQUVWLFFBQUEsSUFBSSxHQUFHLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsR0FBRyxFQUFFLElBQUksRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFXLENBQUEifQ==